<h1 class="mt-8 my-4 text-3xl font-bold">404 - Page Not Found</h1>
<p class="text-lg text-primary-300">Opps !! Looks like this page does not exist, or it has been moved to a different
    location on our
    site.</p>
<p class="text-lg mt-2 mb-4 text-primary-300">Please return to the home page to find your way to the content you are
    looking for. Thanks.
</p>
<button type="button"
    class="bg-secondary-500 hover:bg-primary-700 active:bg-primary-300 disabled:bg-primary-200 text-left text-white mt-2 font-bold text-sm uppercase rounded px-4 py-2 my-4"
    (click)="goHome()">Go Home</button>